import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

export default class WorkordersController extends Controller {
  static targets = ['selector', 'usersHolder', 'editUsers', 'emailField', 'emailInput', 'emailError'];

  connect () {
    if (this.hasSelectorTarget) {
      this.initializeTomSelect(this.selectorTarget)
    }
  }

  disconnect () {
    this.tomSelect.destroy()
    this.tomSelect = null
  }

  initializeTomSelect (selectorElement) {
    this.tomSelect = new TomSelect(selectorElement, {
      create: false,
      sortField: {
        field: 'text',
        direction: 'asc'
      },
      searchField: ['text'],
      plugins: ['remove_button'],
      placeholder: 'Select activity types'
    })
  }

  toggleEditStatusForm (event) {
    const statusType = event.currentTarget.dataset.statusType
    const form = this.element.querySelector(`#workorder-${statusType}`)
    const holder = this.element.querySelector(`#edit-${statusType}`)

    if (form && holder) {
      event.preventDefault()
      form.classList.toggle('hidden')
      holder.classList.toggle('hidden')
    }
  }

  toggleOptionsField (event) {
    const checkbox = event.target

    if (checkbox.name === 'should_create_bulk_workorders') {
      const bulkField = this.element.querySelector('[data-bulk-field]')

      if (checkbox.checked) {
        bulkField.classList.remove('hidden')
        this.selectorTarget.setAttribute('required', 'required')
      } else {
        bulkField.classList.add('hidden')
        this.selectorTarget.removeAttribute('required')
      }
    }

    if (checkbox.name === 'should_send_completion_email') {
      const emailField = this.element.querySelector('[data-email-field]')

      if (checkbox.checked) {
        emailField.classList.remove('hidden')
        this.emailInputTarget.setAttribute('required', 'required')
      } else {
        emailField.classList.add('hidden')
        this.emailInputTarget.removeAttribute('required')
        this.clearError()
      }
    }
  }

  validateEmails () {
    const value = this.emailInputTarget.value
    const emails = value.split(',').map(email => email.trim()).filter(email => email.length > 0)

    const invalidEmails = emails.filter(email => !this.isValidEmail(email))

    if (invalidEmails.length > 0) {
      this.showError(`Invalid email(s): ${invalidEmails.join(', ')}`)
    } else {
      this.clearError()
    }
  }

  isValidEmail (email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  showError (message) {
    this.emailErrorTarget.textContent = message
    this.emailErrorTarget.classList.remove('hidden')
  }

  clearError () {
    this.emailErrorTarget.textContent = ''
    this.emailErrorTarget.classList.add('hidden')
  }

  toggleEditUsersForm (event) {
    event.preventDefault()
    this.usersHolderTarget.classList.toggle('hidden')
    this.editUsersTarget.classList.toggle('hidden')
  }
}
